// @mui
import HomeCertificate from '../home-certificate';

// ----------------------------------------------------------------------

export default function HomeView() {

  return (
    <HomeCertificate />
  );
}
